import React from 'react';
import { SubmitButton } from 'Components/Fields/Buttons';
import { Modal } from 'Components/Modal';
import './RestartPlanModal.css';

export function RestartPlanModal({ isShowing, onClose, planName }) {
  return (
    <Modal isShowing={isShowing} onClose={onClose}>
      <div className="restartPlanModalContainer">
        <div className="restartPlanMessage">
          Thank you for restarting your {planName} subscription to Fox Nation.
          <br />
          Your account will auto-renew on your next billing date.
        </div>
        <SubmitButton text="Close" onClick={onClose} />
      </div>
    </Modal>
  );
}
